export default "__VITE_ASSET__BqYTgu5$__"